import React from "react";
import Icon from "@mdi/react";
import {
  mdiArrowAll,
  mdiArrowTopRightThick,
  mdiCursorDefaultClickOutline,
} from "@mdi/js";

const GUIDE_STORAGE_KEY = "morph.markup.guideSeen";

const hasSeenGuide = () => {
  try {
    return sessionStorage.getItem(GUIDE_STORAGE_KEY) === "1";
  } catch (_) {
    return false;
  }
};

const markGuideSeen = () => {
  try {
    sessionStorage.setItem(GUIDE_STORAGE_KEY, "1");
  } catch (_) {
    // ignore
  }
};

const GUIDE_ROWS = [
  { icon: mdiArrowTopRightThick, label: "Drag to add arrow" },
  {
    icon: mdiCursorDefaultClickOutline,
    label: "Click an arrow to show anchor points",
  },
  { icon: mdiArrowAll, label: "Drag anchor to adjust length & direction" },
  { icon: mdiArrowAll, label: "Drag arrow to move it" },
];

const AnnotationGuide = ({ onDismiss }) => (
  <button
    type="button"
    className="markup-guide-overlay"
    onClick={onDismiss}
    aria-label="Dismiss annotation guide"
  >
    <ul className="markup-guide-rows">
      {GUIDE_ROWS.map(({ icon, label }) => (
        <li key={label} className="markup-guide-row">
          <Icon path={icon} size={0.75} className="markup-guide-row-icon" />
          <span className="markup-guide-row-label">{label}</span>
        </li>
      ))}
    </ul>
  </button>
);

export { hasSeenGuide, markGuideSeen };
export default AnnotationGuide;
